import React from 'react'
import { ImageField, Item, TextField } from '../../../types/SitecoreAdapter'
import { Image } from '@sitecore-jss/sitecore-jss-react'
// Security Images Adapter
export type SecurityImagesProps = Item<{
  securityImages: Item<{
    href: TextField
    text: TextField
    mobileImage: ImageField
    image: ImageField
  }>[]
}>

export const securityImagesAdapter = ({
  fields: { securityImages },
}: SecurityImagesProps) => {
  return securityImages.map(
    ({ fields: { href, text, mobileImage, image } }) => {
      return {
        text: text && text.value,
        href: href && href.value,
        image: image && <Image field={image} loading="lazy" />,
        mobileImage: mobileImage && (
          <Image field={mobileImage} loading="lazy" />
        ),
      }
    }
  )
}
